<mat-toolbar>
  Usuarios
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Volver a Ajustes" routerLink="/settings"><mat-icon color="primary">arrow_back</mat-icon></button>
  <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    @if (userRolCheck('permiso_total')) {
      <button mat-menu-item (click)="newUsuario()"><mat-icon color="primary">add_circle_outline</mat-icon> Añadir Usuario</button>
    }
    <button mat-menu-item (click)="saveExcel()"><mat-icon color="primary">description</mat-icon> Exportar Tabla</button>
  </mat-menu>
</mat-toolbar>

@if (loadingBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <div class='tableHeader'>
    <mat-form-field  class='buscarInput searchMobile'>
      <mat-label>Buscar</mat-label>
      <input matInput type="text" [(ngModel)]="filter" placeholder="" (keyup)="applyFilter($event)">
    </mat-form-field>
    <mat-form-field class="searchMobile">
      <mat-label>Estado</mat-label>
      <mat-select [(value)]="active" (selectionChange)="getUsuarios()">
        <mat-option value="all">Todos</mat-option>
        <mat-option value="true">Activos</mat-option>
        <mat-option value="false">Inactivos</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef > </th>
        <td mat-cell *matCellDef="let element" class='miniCell'>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon matTooltip="Acciones">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editUsuario(element.id)">
              <mat-icon color="primary">create</mat-icon>
              <span>Modificar</span>
            </button>
            <button mat-menu-item (click)="editPasswordUsuario(element.id)">
              <mat-icon color="primary">lock</mat-icon>
              <span>Contraseña</span>
            </button>
            @if (userRolCheck('permiso_total')) {
              <button mat-menu-item (click)="deleteUsuario(element.id)">
                <mat-icon color="primary">delete</mat-icon>
                <span>Eliminar</span>
              </button>
            }
          </mat-menu>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>
      <ng-container matColumnDef="surname">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Apellidos </th>
        <td mat-cell *matCellDef="let element"> {{element.surname}} </td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
        <td mat-cell *matCellDef="let element"> {{element.email}} </td>
      </ng-container>
      <!--<ng-container matColumnDef="rol" >
      <th mat-header-cell *matHeaderCellDef> Rol </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="element.rol === 'admin' "> Administrador </span>
        <span *ngIf="element.rol === 'trans' "> Transportista </span>
        <span *ngIf="element.rol === 'clasi' "> Clasificador </span>
        <span *ngIf="element.rol === 'ofici' "> Oficina </span>
      </td>
    </ng-container>-->
    <ng-container matColumnDef="active" >
      <th mat-header-cell *matHeaderCellDef> Estado </th>
      <td mat-cell *matCellDef="let element">
        @if (element.active === 'true' ) {
          <span> Activo </span>
        }
        @if (element.active === 'false' ) {
          <span> Inactivo </span>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<mat-paginator [pageSize]="25" [pageSizeOptions]="pages" showFirstLastButtons></mat-paginator>
</div>
